import { avecLibelleTraduit } from '../i18n/libelles';

/**
 * Correspondance type de sinistre -> sigle, pour la page des liaisons.
 *
 * Meme correspondance que partout ailleurs dans le depot (ListSinistres,
 * DetailsSinistre, NouveauPvModal…) : SURVENU_TOGO -> ET, SURVENU_ETRANGER ->
 * TE. Extraite ici en fonction pure pour rester testable sans rendu - ce
 * depot n'a pas @testing-library/react.
 */
export const TYPE_LIAISON_META = avecLibelleTraduit({
  SURVENU_TOGO: { sigle: 'ET', color: 'geekblue' },
  SURVENU_ETRANGER: { sigle: 'TE', color: 'purple' },
}, 'referentiels:typesLiaison', { champ: 'libelle' });

export const sigleTypeLiaison = (typeSinistre) =>
  TYPE_LIAISON_META[typeSinistre]?.sigle || typeSinistre || '-';
